// packages/shared-hooks/src/engagements/useEngagementChecklist.ts
//
// `GET /engagements/:id/checklist` (#2245 AC-6 / #2247 FR-2) — the CLOSING-phase
// checklist projection, keyed on the **Engagement UUID** (not the lead). READ
// route (`leads.read`); the card renders it read-only. `enabled` gates the
// fetch so a LEAD-phase card never requests a checklist that does not apply.
// During coexistence a projected row carries no seeded items, so the card
// guards the section behind a non-empty `items` list (degrades to nothing).
import { useQuery } from '@tanstack/react-query';
import { ChecklistViewSchema, type ChecklistView } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { engagementsKeys } from './keys.js';

export function useEngagementChecklist(
  engagementId: string | null,
  options?: { enabled?: boolean },
) {
  const client = useApiClient();
  const enabled = (options?.enabled ?? true) && !!engagementId;
  return useQuery<ChecklistView>({
    queryKey: engagementsKeys.checklist(engagementId ?? ''),
    enabled,
    queryFn: ({ signal }) =>
      client.get<ChecklistView>(
        `/engagements/${engagementId}/checklist`,
        { signal },
        ChecklistViewSchema,
      ),
  });
}
